module.exports = __webpack_public_path__ + "a70599ad1708639ab0448075b3c09d78.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_l_20.mp3
// module id = 457
// module chunks = 0